import React from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";

import { Button as MuiButton, Typography, Stack } from "@mui/material";
import { spacing } from "@mui/system";

const Button = styled(MuiButton)(spacing);

function Page404 () {
    return (
        <Stack p={3} alignItems="center">
            <Typography mt={10} component="h1" variant="h1" align="center" gutterBottom>
                404
            </Typography>
            <Typography component="h2" variant="h5" align="center" gutterBottom>
                Page not found.
            </Typography>
            <Typography component="h2" variant="body1" align="center" gutterBottom>
                The page you are looking for might have been removed.
            </Typography>

            <Button
                component={Link}
                to="/Login"
                variant="contained"
                mt={2}
            >
                Return to website
            </Button>
        </Stack>
    );
}

export default Page404;
